import operatorApiService from "../../../../../services/operator-api.service";
import { intRequest } from "../../../../../utils/sendData";
import { ObserveRefreshData, Vehicle } from "../../../../../types/observe";
import "./CrArea.scss";

interface CrAreaProps {
  refreshData: ObserveRefreshData | null;
  observeCC: string | null;
  vehicle: Vehicle | null;
  sendData: (msg: object) => void;
}

const CrArea = ({ refreshData, observeCC, vehicle, sendData }: CrAreaProps) => {
  const isSelecting = refreshData?.info?.is_selecting;
  const sr = observeCC;
  const dt = vehicle?.vehicle_communication_code;

  const confirmationLabel = refreshData?.cr
    ? `確認要求：${refreshData?.cr.confirmation_request_class_name}`
    : "";

  const handleClick = async () => {
    if (!sr || !dt) return;

    try {
      const response = await operatorApiService.doGetFirstConfirmationRequest(
        refreshData?.drive?.vehicle_id
      );

      const num = parseInt(response.cr.confirmation_request_class_cd, 10);
      const bitFlag = 1 << (num - 1);
      const hex = "0x" + bitFlag.toString(16).padStart(32, "0").toUpperCase(); // 16バイトの16進数文字列に変換

      if (response?.cr?.confirmation_response_cd === "1") {
        sendData(intRequest(sr, dt, "00", hex));
      } else if (response?.cr?.confirmation_response_cd === "0") {
        sendData(intRequest(sr, dt, "C0", hex));
      }
    } catch (err) {
      console.error("確認要求送信失敗", err);
    }
  };

  return (
    <>
      <div className="crArea">
        <button
          className={`crStartButton ${
            refreshData?.cr
              ? isSelecting === "1"
                ? refreshData.cr.confirmation_response_cd === "1"
                  ? "complete"
                  : "request"
                : "noCr"
              : "noCr"
          }`}
          disabled={isSelecting !== "1"}
          onClick={handleClick}
        >
          {refreshData?.cr?.confirmation_response_cd === "1"
            ? "確認完了"
            : "確認開始"}
        </button>
        <input
          className="crText"
          type="text"
          readOnly
          value={confirmationLabel}
        />
      </div>
    </>
  );
};

export default CrArea;
